<script>
  import { onMount } from 'svelte';
  import APIClient from '../state-charts/api-client';
  import MerchantSelector from '../forms/MerchantSelector.svelte';
  import session from '../lib/session';
  import { TS } from '../config/translation-keys.js';
  import { t9n } from '../lib/translate.js';
  import { show_message } from '../lib/flash';
  import router from '../lib/router';

  export let page_state;
  export let invite_token;
  export let invite_partner;
  export let merchant_uuid = 0;

  let list_items = [];
  let merchant_name;
  let register_label;
  let tou_accepted = false;
  let accept_text;
  let is_registered = false;
  let is_code_valid = false;
  let private_merchant_code = '';
  let show_private_merchant_code_field = false;
  let invite_desc = false;
  let invite_msg;
  let is_private;
  let initialized = false;
  let private_merchant = null;
  let disabled = false;
  let wait_api = false;

  let reg_anoth_serv = t9n(TS.SERVICE_SWITCHER_ANOTHER_BTN);
  let desc = t9n(TS.SERVICE_SWTICHER_ANOTHER_DESC);
  let tou_by = t9n(TS.SERVICE_SWITCHER_TOU_BY);
  let tou_tou = t9n(TS.SERVICE_SWITCHER_TOU_TOU);
  let tou_os = t9n(TS.SERVICE_SWITCHER_TOU_OS);
  let btn_back = t9n(TS.TXT_BACK);
  let btn_reg = t9n(TS.REGISTER_LABEL_REGISTER);
  let inviter = t9n(TS.INVITE_YOU_HAVE_BEEN_INVITED);
  let with_message = t9n(TS.INVITE_WITH_COMMENT);

  const is_registered_merchant = id => {
    return !!$session.user.registered_merchants.find(rm => rm.id === id);
  };

  const handle_register = async () => {
    if (!is_registered && !is_registered_merchant(merchant_uuid)) {
      wait_api = true;
      await APIClient.register_for_merchant({ merchant_uuid: merchant_uuid });
      page_state = false;
      wait_api = false;
    } else {
      show_message(t9n(TS.SWITCH_MERCHANT_REGISTERED), 'error');
      setTimeout(() => (window.location.search = ''), 5000);
    }
  };

  const trigger_event = (el, type) => {
    if ('createEvent' in document) {
      // modern browsers
      let e = document.createEvent('HTMLEvents');
      e.initEvent(type, false, true);
      el.dispatchEvent(e);
    } else {
      // IE 8
      let e = document.createEventObject();
      e.eventType = type;
      el.fireEvent('on' + e.eventType, e);
    }
  };

  const set_merchant = async m_id => {
    let merchant;


    if (m_id && m_id !== 0) {
      merchant = await APIClient.get_merchant_config({ merchant_uuid: m_id });
      merchant_uuid = merchant.merchant_uuid;
      merchant_name = merchant.service.selection_name;
    }

    list_items = [
      {
        val: merchant_uuid,
        name: merchant_name,
        seq: merchant.service.sequence_number,
        description: merchant.description,
      },
    ];

    disabled = true;
  };

  const set_private_merchant = () => {
    let el = document.querySelector('[name="private_merchant_code"]');
    el.value = private_merchant_code;
    trigger_event(el, 'keyup');
    document
      .querySelector('#merchant_selector-input')
      .setAttribute('disabled', 'disabled');
  };

  const check_is_private = id => {
    return !$session.api_config.merchants.find(m => m.id === id);
  };

  const create_invite_message = async token => {
    let merchant_data = await APIClient.get_invite_token(token);

    if (!!merchant_data) {
      private_merchant_code = merchant_data.private_code;
      private_merchant = await APIClient.get_merchant_config({
        merchant_uuid: merchant_data.merchant_uuid,
      });
      invite_desc = true;

      if (merchant_data.comment) {
        return (
          `${invite_partner} ${inviter}/${private_merchant.service.selection_name}. ${with_message} ` +
          merchant_data.comment
        );
      } else {
        return `${invite_partner} ${inviter}/${private_merchant.service.selection_name}`;
      }
    }
  };

  const handle_back = () => {
    page_state = false;
    // window.location.search = '';
  };

  const merchant_tooltip_fader = () => {
    let selector = document.querySelector('#merchant_selector-input');
    if (selector) {
      selector.addEventListener('focus', function() {
        document.getElementById('tooltip').style.opacity = '0.3';
      });
      selector.addEventListener('blur', function() {
        document.getElementById('tooltip').style.opacity = '1';
      });
    }
  };

  // initialization ----------------------------------------------------------- //

  const init = async () => {
    merchant_tooltip_fader();

    if (!!invite_token) {
      if (!initialized) {
        is_private = check_is_private(merchant_uuid);
        invite_msg = await create_invite_message(invite_token);

        if (is_private) {
          set_private_merchant();
        }
        if (is_registered_merchant(merchant_uuid)) {
          return router.navigate('/switch-service');
        }
        await set_merchant(merchant_uuid);
        initialized = true;
      }
    } else {
      // let not_registered = $session.api_config.merchants.filter(
      //   m => !is_registered_merchant(m.uuid)
      // );
      //
      // let available_merchants = not_registered.filter(
      //   m => m.country === $session.merchant.country_code
      // );
      let available_merchants = [];

      $session.api_config.merchants.forEach(e => {
        $session.api_config.available_merchants.forEach(f => {
          if (e.uuid === f.uuid) available_merchants.push(e);
        })
      });



      list_items = available_merchants.map(m => {
        return {
          name: m.name,
          selection_name: m.selection_name,
          merchant_uuid: m.uuid,
          sequence_number: m.sequence_number,
          country: m.country,
          description: m.description,
          active: m.uuid === $session.merchant.merchant_uuid,
        };
      });
    }
  };

  onMount(async () => await init());

</script>

<div style="text-align: center;" class="fade-in">
  <h1 style="margin-bottom: 25px" class="mdc-typography--headline5">
    {reg_anoth_serv}
  </h1>

  <div
    id="tooltip"
    class="tooltip-default tooltip-fade-in"
    style="width: 75%; margin: auto;">
    {#if !!invite_desc}
      <div
        id="tooltip_def"
        class="tooltip-text tooltip-top svelte-wb285v"
        style="background-color:var(--mdc-theme-secondary); color: rgb(255, 255,
        255);">
        {invite_msg}
      </div>
    {:else}
      <div
        id="tooltip_def"
        class="tooltip-text tooltip-top svelte-wb285v"
        style="background-color:var(--mdc-theme-secondary); color: rgb(255, 255,
        255);">
        {desc}
      </div>
    {/if}
  </div>

  <div style="width: 75%; margin: auto; margin-top: 9px;">
    <MerchantSelector
      sort_service={true}
      show_hover_tooltip={true}
      id="merchant_selector"
      {disabled}
      {list_items}
      width='450px'
      showed_elements={6}
      bind:value={merchant_uuid}
      bind:private_merchant_code
      bind:name={merchant_name}
      bind:show_private_merchant_code_field
      bind:valid_private_code={is_code_valid} />
  </div>

  <p class='required'>* {t9n(TS.REQUIRED_LABEL)}</p>

  <div
    style="width: 75%; margin-top: 21px;"
    id="switch-chechbox"
    class="mdc-form-field">
    <div id="accept--tou" class="mdc-checkbox">
      <input
        type="checkbox"
        class="mdc-checkbox__native-control"
        id="accept-tou"
        bind:checked={tou_accepted} />

      <div class="mdc-checkbox__background">
        <svg class="mdc-checkbox__checkmark" viewBox="0 0 24 24">
          <path
            class="mdc-checkbox__checkmark-path"
            fill="none"
            d="M1.73,12.91 8.1,19.28 22.79,4.59" />
        </svg>

        <div class="mdc-checkbox__mixedmark" />
      </div>
    </div>

    <label class="checkbox-label" style="text-align: left;" for="accept-tou">
      {#if merchant_uuid === 0 || merchant_uuid === 'private'}
        {tou_by} {tou_tou} {tou_os}
      {:else}
        {tou_by}
        <a href={'/tou/merchant/' + merchant_uuid + '.html'} target="_blank">
          {tou_tou}
        </a>
        {tou_os} ({merchant_name})
      {/if}

    </label>
  </div>

  <div class="actionContainer">
    {#if !!invite_token}
      <span />
    {:else}
      <button
        data-cy="back_button"
        style="margin-right: 10px"
        class="mdc-button mdc-button--raised"
        on:click|preventDefault={handle_back}>
        {btn_back}
      </button>
    {/if}

    {#if merchant_uuid !== 0 && !tou_accepted}
      <button
        data-cy="register_button"
        class="mdc-button mdc-button--raised"
        disabled
        on:click|preventDefault={async () => { await handle_register() } }>
        {btn_reg}
      </button>
    {:else}
      {#if !is_code_valid && show_private_merchant_code_field}
        <button
          data-cy="register_button"
          class="mdc-button mdc-button--raised"
          disabled
          on:click|preventDefault={async () => { await handle_register() } }>
          {btn_reg}
        </button>
      {/if}
      {#if is_code_valid && merchant_uuid === 'private'}
        <button
          data-cy="register_button"
          class="mdc-button mdc-button--raised"
          disabled={wait_api}
          on:click|preventDefault={async () => {  await handle_register() }}>
          {btn_reg}
        </button>
      {/if}
      {#if merchant_uuid !== 0 && merchant_uuid !== 'private'}
        <button
          data-cy="register_button"
          disabled={wait_api}
          class="mdc-button mdc-button--raised"
          on:click|preventDefault={async () => { await handle_register()} }>
          {btn_reg}
        </button>
      {/if}
    {/if}

  </div>
</div>

<style>
    .required{
        font-size: 10pt;
        margin-top: 20px;
        text-align: left;
        margin-left: 77px;
        color: #323232;
        margin-bottom: 0px;
    }

  .checkbox-label {
    color: dimgray;
    font-size: 90%;
    text-align: left;
    margin-top: -16px;
  }

  .mdc-checkbox__background {
    top: 2px;
  }

  .tooltip-fade-in {
    -webkit-transition: all 2s ease-out;
    -moz-transition: all 2s ease-out;
    -o-transition: all 2s ease-out;
    transition: all 2s ease-out;
  }

  .service-label {
    padding-left: 75px;
    padding-right: 75px;
    text-align: justify;
    text-justify: inter-word;
    color: #373737;
    font-size: 0.9rem;
  }

  .tooltip-default .tooltip-text {
    background-color: var(--mdc-theme-secondary);
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 8px 8px;
    display: block;
    padding-left: 30px;
    padding-right: 30px;
    /*width: 437px;*/
    font-size: 13px;
    box-shadow: 1px 1px 3px 0px rgba(0, 0, 0, 0.3);
  }

  .tooltip-default .tooltip-text::after {
    content: ' ';
    position: relative;
    top: 30px;
    /*left: 50%;*/
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: #018786 transparent transparent transparent;
  }
</style>
